import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { OptionList, DateRange } from './components';

const Ticket = (props) => {
    const [ tickets, setTickets ] = useState([]);
    const [ filters, setFilters ] = useState({
        createdStartDate:null,
        createdEndDate:null
    });
    const [ filterOpen, setFilterOpen ] = useState(false);
    const [ filteredTickets, setFilteredTickets ] = useState([]);
    const [ tab, setTab ] = useState('all');

    useEffect(() => {
        setTickets(props.tickets);
        setFilteredTickets(props.tickets);
    },[props.tickets]);

    const onClickTicket = (id) => {
        props.onSelect(id);
    };
    
    const badge = (status) => {
        return status === 'solved' ? 'badge-success' : status === 'processing' ? 'badge-warning' : status === 'deleted' ? 'badge-secondary' : 'badge-danger'
    };

    const onTabSet = (e) => {
        let newFilteredTickets;
        if (e === 'all') {
            newFilteredTickets = tickets;
        } else {
            newFilteredTickets = tickets.filter(i => e === i.status );
        }
        setFilteredTickets(newFilteredTickets);
        setTab(e);
    }

    const onChangeDate = (value) => {
        const data = {
            createdStartDate:moment(value.from).format("YYYY-MM-DD"),
            createdEndDate:moment(value.to).format("YYYY-MM-DD"),
        }
        setFilters({ ...filters, ...data });
        props.onChangeDate(data);
    }

    return (
        <div className="">
            <OptionList
                tab={tab}
                onSelectTab={onTabSet}
                tickets={tickets}
                onClickFilter={() => setFilterOpen(!filterOpen)}
            />
            <DateRange
                open={filterOpen}
                startDate={filters.createdStartDate}
                endDate={filters.createdEndDate}
                onChange={e => onChangeDate(e)}
            />
            {
                filteredTickets.length === 0 ?
                    <div className="text-center p-5">
                        <p><b>Tiket kosong</b></p>
                    </div>
                    :
                    null
            }
            <div style={{overflow:'scroll', height:props.height-40 || 500}}>
            {
                filteredTickets.map(i => (
                    <div key={i.id} className='px-4 py-2 border-bottom hover pointer bg-hover-blue' onClick={() => onClickTicket(i.id)}>
                        <div className='row'>
                            <div className='col-9'>
                                <b>{i.title}</b>
                            </div>
                            <div className='col-3'>
                                {i.createdAt}
                            </div>
                        </div>
                        
                        <div className='row'>
                            <div className='col-9'>
                                <text>{i.description.length > 40 ? i.description.substring(0, 40) + "..." : i.description}</text>
                            </div>
                            <div className='col-3'>
                                <div className={`badge ${badge(i.status)}`}>{i.status}</div>
                            </div>
                        </div>
                        
                    </div>
                ))
            }
            </div>

        </div>
    )
};

export default Ticket